import { retrieveMethod } from "./resource";
const resource = "umprn";
export const retrieve = (client, umprn, request) => retrieveMethod({ resource, client })(umprn, request);
